import React from 'react';
import { getStatusMeta } from '../../constants/partnerStatuses';

// ─────────────────────────────────────────────────────────────────────────────
// ONE BADGE FOR THE PARTNER-FACING STATUS VOCABULARY.
//
// 🚨 EXTRACTED RATHER THAN COPIED. My Borrowers needed the same pill My Buyers
// renders, and the first version of it read meta.bg / meta.fg / meta.border —
// fields getStatusMeta does not return. It returns `color: { bg, color }`, so
// the pill rendered with undefined styling and looked plausible in review.
//
// 🔑 TWO PAGES RENDERING ONE VOCABULARY MUST NOT EACH DECIDE HOW IT LOOKS. The
// labels already come from one source (backend/utils/partnerStatus mirrored in
// constants/partnerStatuses); the rendering is part of that and belongs here.
// ─────────────────────────────────────────────────────────────────────────────
export default function StatusBadge({ status, partnerType }) {
  const meta = getStatusMeta(status, partnerType);
  const s = meta.color;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
      backgroundColor: s.bg, color: s.color, whiteSpace: 'nowrap',
    }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: s.color }} />
      {meta.label}
    </span>
  );
}
